function t(t, r) {
  return t < r ? -1 : t > r ? 1 : t >= r ? 0 : NaN;
}

function r(r) {
  var a;
  return 1 === r.length && (a = r, r = function r(_r, n) {
    return t(a(_r), n);
  }), {
    left: function left(t, a, n, e) {
      for (null == n && (n = 0), null == e && (e = t.length); n < e;) {
        var o = n + e >>> 1;
        r(t[o], a) < 0 ? n = o + 1 : e = o;
      }

      return n;
    },
    right: function right(t, a, n, e) {
      for (null == n && (n = 0), null == e && (e = t.length); n < e;) {
        var o = n + e >>> 1;
        r(t[o], a) > 0 ? e = o : n = o + 1;
      }

      return n;
    }
  };
}

var a = r(t).right,
    n = Math.sqrt(50),
    e = Math.sqrt(10),
    o = Math.sqrt(2);

function h(t, r, a) {
  var n,
      e,
      o,
      h,
      f = -1;
  if (a = +a, (t = +t) === (r = +r) && a > 0) return [t];
  if ((n = r < t) && (e = t, t = r, r = e), 0 === (h = l(t, r, a)) || !isFinite(h)) return [];
  if (h > 0) for (t = Math.ceil(t / h), r = Math.floor(r / h), o = new Array(e = Math.ceil(r - t + 1)); ++f < e;) {
    o[f] = (t + f) * h;
  } else for (t = Math.floor(t * h), r = Math.ceil(r * h), o = new Array(e = Math.ceil(t - r + 1)); ++f < e;) {
    o[f] = (t - f) / h;
  }
  return n && o.reverse(), o;
}

function l(t, r, a) {
  var h = (r - t) / Math.max(0, a),
      l = Math.floor(Math.log(h) / Math.LN10),
      f = h / Math.pow(10, l);
  return l >= 0 ? (f >= n ? 10 : f >= e ? 5 : f >= o ? 2 : 1) * Math.pow(10, l) : -Math.pow(10, -l) / (f >= n ? 10 : f >= e ? 5 : f >= o ? 2 : 1);
}

function f(t, r, a) {
  var h = Math.abs(r - t) / Math.max(0, a),
      l = Math.pow(10, Math.floor(Math.log(h) / Math.LN10)),
      f = h / l;
  return f >= n ? l *= 10 : f >= e ? l *= 5 : f >= o && (l *= 2), r < t ? -l : l;
}

function u(t) {
  for (var r, a, n, e = t.length, o = -1, h = 0; ++o < e;) {
    h += t[o].length;
  }

  for (a = new Array(h); --e >= 0;) {
    for (r = (n = t[e]).length; --r >= 0;) {
      a[--h] = n[r];
    }
  }

  return a;
}

export { h as a, a as b, l as c, r as d, u as m, f as t };